import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setRouterData } from '../../redux/actions';
import { toast } from '../../utils/functions';

export default function Development() {

    const [data, setData] = useState({
        id: '',
        type: 'accident',
    });

    const user = useSelector(store => store.user);
    const dispatch = useDispatch();

    function changeText(value, name) {
        setData(prevState => ({
            ...prevState,
            [name]: value,
        }));
    }
    function accept() {
        if (!data.id) {
           toast('id nist', 'error') ;
           return;
        }
        dispatch(setRouterData({ id: data.id, type: data.type }));
        toast('تایید', 'success');
    }
    function remove() {
        dispatch(setRouterData({}));
        toast('حذف', 'error');
    }

    return (
        <div>
            {
                user.id === 6 &&
                    <div>
                        <input
                            type='text'
                            placeholder='id'
                            onChange={e => changeText(e.target.value, 'id')}
                            value={data.id}
                        />
                        <select
                            onChange={e => changeText(e.target.value, 'type')}
                            value={data.type}
                        >
                            <option value='accident'>accident</option>
                            <option value='register'>register</option>
                            <option value='report'>report</option>
                        </select>
                        <button
                            onClick={accept}
                        >
                            تایید
                        </button>
                        <button
                            onClick={remove}
                        >
                            حذف
                        </button>
                    </div>
            }
        </div>
    );
}